import type { SurveyQuestion } from '../../fetchSurvey/types/index';
import type { CustomFieldValueMap } from '../types/customFieldValues';
import type { LogicContext } from '../types';

function buildQuestionsById(questions: SurveyQuestion[] = []): ReadonlyMap<string, SurveyQuestion> {
  return new Map(questions.map(question => [question.id, question]));
}

export function buildLogicContext(
  answers: LogicContext['answers'],
  questions: SurveyQuestion[] = [],
  customFieldValues: CustomFieldValueMap = {}
): LogicContext {
  return {
    answers,
    questionsById: buildQuestionsById(questions),
    customFieldValues,
  };
}
